<template>
  <div>
    <v-toolbar
      :style="$vuetify.breakpoint.smAndDown ? 'padding-right: 0px;' : 'padding-right: 60px;'"
      style="position: fixed; z-index: 999; width: 100%"
      height="59"
      elevation="3"
    >
      <v-img
        @click="$route.name === 'minhaUnimed' ? (showSuccess = true) : $router.push('/home')"
        class="ml-2 logo"
        :src="require('../../../assets/imgs_unimed/logotipo.png')"
        width="98"
        height="35"
        min-width="98"
        max-width="98"
      />

      <div :class="$vuetify.breakpoint.xs ? 'flex-grow-1' : 'flex-grow-1'"></div>

      <!-- Alerta -->
      <template v-if="alertas.length">
        <div class="text-center">
          <v-menu
            :close-on-content-click="false"
            min-width="460"
            max-width="460"
            v-model="menuAlerta"
            :nudge-bottom="20"
            :nudge-left="200"
            transition="slide-y-transition"
            offset-y
          >
            <template v-slot:activator="{ on: menu, attrs }">

              <v-tooltip bottom :color="colorAlertView" content-class="tooltipBottom">
                <template v-slot:activator="{ on: tooltip }">
                  <v-badge
                    overlap
                    bordered
                    :color="colorAlertView"
                    :content="totalAlertasNaoIgnorados()"
                    offset-x="30"
                    offset-y="10"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                    @click="visualizarAlertas()"
                    v-if="canViewAlerta"
                  >
                    <v-icon
                      class="icon-bell grey3--text mr-6"
                      style="height: 27px; width: 27px"
                      v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }"
                      @click="visualizarAlertas()"
                      v-if="canViewAlerta">
                      $vuetify.icon.bell</v-icon>
                  </v-badge>


                </template>
                <span>{{ messageTooltipView }}</span>
              </v-tooltip>
            </template>
            <v-list class="overflow-y-auto padding-list" :flat="true" max-height="550px">
              <v-list-item v-for="(item, index) in alertas" :key="index" class="no-padding">
                <v-alert
                  dark
                  prominent
                  type="info"
                  :color="item.tipoAlerta.cor"
                  :value="item.showAlert"
                  class="alert-message alert-space"
                  v-bind:style="{ 'background-color': item.tipoAlerta.cor }"
                >
                  <v-row align="center" class="alert-content">
                    <v-col class="grow alert-text">
                        <span v-if="item.mensagemCustomizada">   {{ item.mensagemCustomizada }} </span>
                        <span v-if="!item.mensagemCustomizada">   {{ item.mensagemAlerta }} </span>
                      </v-col>
                    <v-col class="shrink alert-text">
                      <a @click="marcarAlerta(item)" class="ma-1 alert-action-button">Sim</a>
                      <a @click="criarNotificacao(item)" class="alert-action-button">Não</a>
                    </v-col>
                    <v-col class="shrink alert-text">
                      <a @click="ignorarAlerta(item)" class="alert-action-button font16"> x </a>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>

      <v-icon
        v-if="!alertas.length && canViewAlerta"
        class="icon-bell grey3--text mr-6"
        style="height: 27px; width: 27px">
        $vuetify.icon.bell</v-icon>

      <!-- Fim Alerta -->
      <template>
        <v-menu
          content-class="header-menu"
          v-model="menu"
          :close-on-content-click="false"
          min-width="267"
          max-width="300"
          :nudge-bottom="20"
          :nudge-left="237"
          offset-y>
          <template v-slot:activator="{ on }">
            <v-card class="mr-2" style="border-radius: 50px; width: 40px !important" elevation="6">
              <v-avatar class="avatar-header" v-on="url ? on : ''" size="40">
                <v-img
                  v-show="url"
                  @error="errLoading"
                  @load="completeLoad"
                  style="border: solid white 1.5px"
                  :src="url != 'url' ? url : require('../../../assets/user.png')"
                />

                <spinner-cadu
                  v-show="loading && !url"
                  :line-size="lineSize"
                  :line-fg-color="$vuetify.theme.themes.light.primary1"
                  size="20"
                />
              </v-avatar>
            </v-card>
          </template>

          <v-card elevation="12" style="border-radius: 8px">
            <v-list class="py-0 ml-1">
              <v-list-item class="pa-0">
                <v-list-item-avatar class="mr-0 ml-2 pt-10 pb-10" size="60">
                  <v-card style="border-radius: 50px; width: 60px; height: 60px" elevation="3">
                    <v-img
                      v-show="url"
                      style="border: green solid 2px; position: relative; top: 2.3px"
                      :src="url != 'url' ? url : require('../../../assets/user.png')"
                    />
                  </v-card>
                </v-list-item-avatar>

                <v-list-item-content class="ml-3 pt-4 py-2">
                  <v-list-item-title
                    class="font-primaria subtitle-2 font-weight-bold primary1--text px-0 pt-0 pb-1 ml-1"
                  >
                    {{ nome }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="overlineLoweCase fontColor1--text px-0 pt-0 pb-1 ml-1">
                    {{ email.toLowerCase() }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle class="overline fontColor1--text px-0 pt-0 pb-1 ml-1">
                    {{ unimed }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle class="overline fontColor1--text px-0 pt-0 pb-1 ml-1">
                    {{ login }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle
                    class="overline font-weight-bold primary1--text px-0 pt-0 pb-1 ml-1 change-image"
                  >
                    <button @click="$emit('change-image')">{{ nameChangeImage }}</button> |
                    <button @click="$emit('change-data')">EDITAR DADOS</button>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider class="mt-2 mb-2"></v-divider>

            <v-row class="ml-4 mr-2" align="center" justify="space-between">
              <v-col class="pa-0 pt-1 ml-1" cols="12">
                <div class="caption fontColor1--text"><span class="primary1--text">Tipo de Área: </span>{{ area }}</div>
              </v-col>

              <v-col class="pa-0 pt-1 ml-1" cols="12">
                <div class="caption fontColor1--text"><span class="primary1--text">Cargo: </span>{{ cargo }}</div>
              </v-col>

              <v-col class="px-0 py-1 ml-1" cols="12">
                <div class="caption fontColor1--text"><span class="primary1--text">Telefone: </span>{{ telefone }}</div>
              </v-col>

              <v-col class="px-0 pt-0 pb-1 ml-1" cols="12">
                <div class="caption fontColor1--text"><span class="primary1--text">Perfil: </span>{{ perfil }}</div>
              </v-col>
            </v-row>

            <v-divider class="mt-3 mb-3"></v-divider>

            <v-card-actions class="pa-1">
              <a class="primary1--text ml-4 caption" @click="logout">Sair</a>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>
    </v-toolbar>
    <overlay-loading v-model="loadingAlert" />
    <versao-modal @salvarVersao="goToHome" v-model="showSuccess" />
    <error-modal v-model="showError" :errObj="errObj" :titulo="'Há algo errado.'" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import Unimed from '@/services/Unimed'
import Logout from '@/services/Logout/Logout'
import Redirect from '@/services/Redirect'
import Alertas from '@/services/Alertas/Alertas'
import Notificacoes from '@/services/Notificacoes/Notificacoes'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  mounted() {
    this.tokenBearer = localStorage.getItem('tokenBearer');
    let decoded = jwtDecode(this.tokenBearer);
    this.role = decoded.role;
    this.idUnimed = localStorage.getItem('idUnimed');
    this.versaoUnimed = localStorage.getItem('versaoUnimed');
    this.alertasIgnorados = this.obterAlertasIgnorados();
  
    if (this.canViewAlerta) {
      this.carregaAlertas();
    }
  },
  data() {
    return {
      menu: false,
      menuAlerta: false,
      showTooltip: true,
      messageTooltip: 'Novo alerta',
      colorAlert: '#00995d',
      loadingAlert: false,
      idUnimed: -1,
      versaoUnimed: -1,
      nome: '',
      email: '',
      unimed: '',
      login: '',
      area: '',
      cargo: '',
      telefone: '',
      perfil: '',
      role: '',
      tokenBearer: '',
      img: '',
      url: 'url',
      loading: false,
      lineSize: 1,
      errObj: {
        status: 'Status',
        error: 'Erro'
      },
      showSuccess: false,
      showError: false,
      normalErr: false,
      bool: localStorage.getItem('optionEdit'),
      nameChangeImage: 'TROCAR FOTO',
      alertas: [],
      alertasIgnorados: [],
      poolingAlerts: null
    }
  },
  async beforeMount() {},
  async beforeCreate() {
    var self = this;
    EventBus.$on('atualizarAlertas', () => {
      self.carregaAlertas();
    })
    EventBus.$on('resolverAlertaNotificaoPendente', (itemData) => {
      // Finalizar alerta e notificações
      self.concluirNotificacaoAlerta(self.idUnimed, self.versaoUnimed, itemData.tipoNotificacao)
    })
  },
  beforeDestroy() {
    clearInterval(this.poolingAlerts)
  },
  created() {
    this.pollAlerts();
  },
  methods: {
    async goToHome() {
      if (this.$router.currentRoute.name === 'minhaunimed' && this.bool === 'true') {
        const unimed = new Unimed(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)

        await unimed.putCancelEdit().then(() => (this.showSuccess = false))
      }
      this.$router.push({ path: '/home' })
    },
    async logout() {
      const logout = new Logout(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)

      await logout.exit().then(({ data }) => {
        localStorage.removeItem('fotoPerfil')
        localStorage.removeItem('tokenBearer')
        localStorage.removeItem('situacaoUnimed')
        localStorage.removeItem('optionEdit')
        window.location.href = data
      })
    },
    completeLoad() {
      this.loading = false
    },
    async criarNotificacao(alerta) {
      this.loadingAlert = true
      /// this.fecharAlerta(alerta);
      const notificationService = new Notificacoes(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      await notificationService
        .gerarNotificacao(alerta.idAlerta)
        .then(() => {
          this.removerAlerta(alerta);
          this.removerAlertaIgnorado(alerta);
          EventBus.$emit('geradaNovaNotificacao', alerta);
          this.loadingAlert = false;
        })
        .catch((err) =>
          this.setError(err, 'Ocorreu um erro ao gerar notificação, por favor tente novamente mais tarde.')
        )
    },
    ignorarAlerta(alerta) {
      this.menuAlerta = false;
      const alertasIgnorados = this.obterAlertasIgnorados();
      if(alertasIgnorados !== null && alertasIgnorados.length) {
        if(!this.existInArray(alertasIgnorados, alerta)) {
          alertasIgnorados.push({...alerta, showAlert: false, expires: this.getExpireDate()});
          localStorage.setItem('alertasIgnorados', JSON.stringify(alertasIgnorados));
          this.alertasIgnorados = alertasIgnorados;
        }
      } else {
        // se for vazio
        alerta = {...alerta, showAlert: false, expires: this.getExpireDate()};
        if(!this.existInArray(this.alertasIgnorados, alerta)) {
          this.alertasIgnorados.push(alerta);
        }
        localStorage.setItem('alertasIgnorados', JSON.stringify(this.alertasIgnorados));
      }
      this.removerAlerta(alerta);
      this.menuAlerta = false;
    },
    visualizarAlertas() {
      this.alertas = this.alertas.map((obj) => {
        return { ...obj, showAlert: true }
      })
      this.menuAlerta = true
    },
    ativarAlerta(alerta) {
      this.menuAlerta = true;
      // remove da lista de ignorados
      this.alertasIgnorados = this.alertasIgnorados.filter(function (value) {
        return value.idAlerta != alerta.idAlerta;
      })

      this.alertas.push(alerta);

      // ativa o alerta
      this.alertas = this.alertas.map((obj) => {
        if (obj.idAlerta == alerta.idAlerta) {
          return { ...obj, showAlert: true }
        }
        return obj
      })
    },
    getExpireDate() {
      var date = new Date();
      // a cada 5 minutos 
      const minutes = 5;
      date.setTime(date.getTime()+(minutes*60*1000));
      return date.getTime();
    },
    marcarAlerta(alerta) {
      const currentRoute = this.$router.history.current.path
      const redirectService = new Redirect(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      const redirectItem = redirectService.getRedirectNotification(alerta.tipoAlerta.valor)
      const currentPageItem = '/' + redirectItem.name
      this.fecharAlerta(alerta)
      if (currentRoute === currentPageItem && redirectItem.name === 'minhaunimed' && redirectItem.tab === 'historico') {
        EventBus.$emit('changeAbaMinhaUnimed', redirectItem)
      } else if (redirectItem.name === 'minhaunimed' && redirectItem.tab === 'historico') {
        this.$router.push({ name: redirectItem.name, params: { idUnimed: this.idUnimed, currentTab: redirectItem } })
      } else if (redirectItem.name === 'minhaunimed' && redirectItem.tab !== 'historico') {
        EventBus.$emit('editarVersaoUnimed', redirectItem)
      } else {
        this.$router.push({ name: redirectItem.name })
      }
    },
    removerAlerta(alerta) {
      this.alertas = this.alertas.filter((obj) => {
        if (obj.idAlerta != alerta.idAlerta) {
          return obj
        }
      })
    },
    removerAlertaIgnorado(alerta) {
      let alertasIgnorados = this.obterAlertasIgnorados();
      this.alertasIgnorados = alertasIgnorados.filter((obj) => {
        if (obj.idAlerta != alerta.idAlerta) {
          return obj
        }
      });
      localStorage.setItem('alertasIgnorados', JSON.stringify(this.alertasIgnorados));
    },
    fecharAlerta(item) {
      this.menuAlerta = false
      this.alertas = this.alertas.map((obj) => {
        if (obj.idAlerta == item.idAlerta) {
          return { ...item, showAlert: false }
        }
        return item;
      })
    },
    ocultarAlerta(item) {
      this.alertas = this.alertas.map((obj) => {
        if (obj.idAlerta == item.idAlerta) {
          return { ...item, showAlert: false }
        }
        return item;
      });
      this.menuAlerta = false
    },
    errLoading() {
      this.loading = false
      this.loadingAlert = false
    },
    existInArray(arr, obj) {
      return arr.some((value) => {
        return value.idAlerta == obj.idAlerta
      })
    },
    async dadosMenu(data) {
      this.loading = true

      this.nome = data.nome
      this.email = data.emailCorporativo
      this.unimed = data.unimed.nomeFantasia
      this.login = data.login
      this.telefone = data.telefoneCorporativo
      this.perfil = data.papel

      this.area = data.tipoArea ? data.tipoArea.nome : null
      this.cargo = data.cargo ? data.cargo.nome : null
      this.url = data.foto
        ? `${this.$appConfig.config.API}/api/arquivos/${data.foto.container}/${data.foto.uuid}`
        : 'url'

      localStorage.setItem('fotoPerfil', this.url)

      if (this.url === 'url') {
        this.nameChangeImage = 'CARREGAR FOTO'
      }
    },
    async carregaAlertas() {
      const alertaService = new Alertas(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      await alertaService.consultarAlertas().then(({ data }) => {
          this.alertas = [];
          const alertasIgnorados = this.obterAlertasIgnorados();
          data.forEach((alerta) => {            
            if(!this.existInArray(alertasIgnorados, alerta)) {
              this.alertas.push({ showAlert: true, ...alerta });
            }
          });
        }).catch(() => {})
    },
    setError(err, message) {
      console.error('Ocorreu ao gerar notificação a partir de um alerta.')
      console.error(err)
      this.showError = true
      this.loadingAlert = false
      this.errObj.status = err.response.status
      if (message !== null) {
        this.errObj.error = message
      } else {
        this.errObj.error = err.message
      }
    },
    obterAlertasIgnorados() {
      const itens = localStorage.getItem('alertasIgnorados');
      if (itens != null) {
        return JSON.parse(itens);
      } 
      return [];
    },
    async concluirNotificacaoAlerta(idUnimed, versaoUnimed, tipoNotificacao) {
      // Conclui os alertas
      var self = this
      const alertaService = new Alertas(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      await alertaService
        .marcarAlertaComoResolvido(idUnimed, versaoUnimed, tipoNotificacao)
        .then(() => {
          self.carregaAlertas()
        })
        .catch((err) => {
          console.error(err, 'Não foi possível marcar alerta como resolvido.')
        });

      // Conclui as notificacoes
      const notificacaoService = new Notificacoes(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      await notificacaoService
        .marcarNotificacaoComoResolvido(idUnimed, versaoUnimed, tipoNotificacao)
        .then(() => { })
        .catch((err) => {
          console.error(err, 'Não foi possível marcar notificação como resolvida.')
        })
    },
    totalAlertasNaoIgnorados() {
      return this.alertas.length;
    },
    pollAlerts() {
      var self = this;
      this.poolingAlerts = setInterval(() => {
        this.verificaAlertasIgnorados(self);
      }, 60000);
    },
    verificaAlertasIgnorados(self) {
      let alertasIgnorados = this.obterAlertasIgnorados();
      alertasIgnorados.forEach(alerta => {
        if(self.role !== 'admin_brasil' && alerta.tipoAlerta.valor !== "PENDENCIA" ) {
          this.verificaSeAlertaExpirou(self, alerta, alertasIgnorados);
        } else if(self.role === 'admin_brasil') {
          this.verificaSeAlertaExpirou(self, alerta, alertasIgnorados);
        }
      });
    },
    verificaSeAlertaExpirou(self, alerta, alertasIgnorados) {
      const now = new Date();
       // se alerta expirado
      if(alerta.expires < now.getTime()) {
        if(!self.existInArray(self.alertas, alerta)) {
          self.alertas.push({...alerta, showAlert: true});
        }
        // remove da lista de ignorados
        alertasIgnorados = alertasIgnorados.filter((obj) => obj.idAlerta != alerta.idAlerta);
        localStorage.setItem('alertasIgnorados', JSON.stringify(alertasIgnorados));
      }
    }
  },
  computed: {
    showMenu() {
      return this.area && this.cargo && this.email
    },
    canViewAlerta() {
      const allowedRoles = ['admin_brasil', 'admin', 'dirigente']
      return allowedRoles.indexOf(this.role) !== -1
    },
    messageTooltipView() {
      if (this.alertas.length != 0) {
        const alerta = this.alertas[0]
        return alerta.tipoAlerta.nome
      }
      return "";
    },
    colorAlertView() {
      if (this.alertas.length != 0) {
        const alerta = this.alertas[0];
        return alerta.tipoAlerta.cor;
      }
      return "";
    }
  },
  watch: {
    url() {
      localStorage.setItem('fotoPerfil', this.url)
      if (this.url === 'url') {
        this.nameChangeImage = 'CARREGAR FOTO'
      } else {
        this.nameChangeImage = 'TROCAR FOTO'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.font16
  font-size: 16px

.alert-message
  margin-bottom: 0px
  font-size: 14px
  padding: 14px

.alert-space
  margin-bottom: 10px

.alert-green
  background: #00995d !important

.alert-red
  background: #CD5C5C !important

.alert-yellow
  background: #FFD700 !important

.alert-action-button
  padding: 5px
  color: #6c6767
  text-decoration: none

.alert-content
  background-color: #ffff
.alert-message > i
  color: #ffff

.padding-list
  padding: 10px
.no-padding
  padding: 0px !important
.alert-text
  color: rgba(0, 0, 0, 0.6)

.borde-green
  border: 1px solid #0064008f
.icon-bell
  &:hover
    color: #9e9e9e !important
    cursor: pointer

.avatar-header
  &:hover
    cursor: pointer

.header-menu > .overline
  font-size: 0.625rem !important
  font-weight: 400
  letter-spacing: 0.1666666667em !important
  line-height: 1rem
  text-transform: uppercase
  letter-spacing: 0.04px !important

.header-menu > .overlineLoweCase
  font-size: 0.725rem !important
  font-weight: 400
  letter-spacing: 0.1666666667em !important
  line-height: 1rem
  text-transform: lowercase
  letter-spacing: 0.04px !important

.header-menu
  margin: 0 6px!important
  border-radius: 10px!important

.change-image
  &:hover
    cursor: pointer

.logo
  cursor: pointer
  margin-left: 19px !important

.v-alert--prominent .v-alert__icon.v-icon
  padding: 5px

.v-alert--prominent .v-alert__icon.v-icon::after
  opacity: 0 !important

.tooltipBottom::before
  border-right: solid 8px transparent
  border-left: solid 8px transparent
  transform: translateX(-50%)
  position: absolute
  z-index: -21
  content: ''
  bottom: 100%
  left: 50%
  height: 0
  width: 0
</style>
